'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _TabsWrapper = require('components/Tabs/TabsWrapper/TabsWrapper');

var _TabsWrapper2 = _interopRequireDefault(_TabsWrapper);

var _Tab = require('components/Tabs/Tab/Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatisticsTabs = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(StatisticsTabs, _Component);

  function StatisticsTabs() {
    (0, _classCallCheck3.default)(this, StatisticsTabs);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsTabs.__proto__ || (0, _getPrototypeOf2.default)(StatisticsTabs)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsTabs, [{
    key: 'getActiveRoute',
    value: function getActiveRoute() {
      return (0, _get3.default)(this, ['context', 'router', 'routes', 3, 'path']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          projectId = _props.projectId,
          recipientId = _props.recipientId;
      var t = this.context.t;

      var projectRoute = '/statistics/project' + (projectId ? '/' + projectId : '');
      var recipientRoute = '/statistics/recipient' + (recipientId ? '/' + recipientId : '');
      var activeTab = this.getActiveRoute();

      return _react2.default.createElement(
        _TabsWrapper2.default,
        { className: (0, _bind2.default)(className), pullRight: true },
        _react2.default.createElement(_Tab2.default, {
          title: t('Project Activity'),
          to: projectRoute,
          active: activeTab === 'project'
        }),
        _react2.default.createElement(_Tab2.default, {
          title: t('Recipient Activity'),
          to: recipientRoute,
          active: activeTab === 'recipient'
        }),
        _react2.default.createElement(_Tab2.default, {
          title: t('Devices'),
          to: '/statistics/devices',
          active: activeTab === 'devices'
        })
      );
    }
  }]);
  return StatisticsTabs;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  projectId: _propTypes2.default.number,
  recipientId: _propTypes2.default.number
}, _class.contextTypes = {
  router: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp);
exports.default = StatisticsTabs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsTabs/StatisticsTabs.js
// module id = 2127
// module chunks = 1